/* ============================================================
   LEGENDARY FITMENT — BUNDLE CONFIGURATOR
   bundle-configurator.js
   ============================================================ */

(function () {
  'use strict';

  // ── State ──────────────────────────────────────────────────
  let state = {
    make: null,
    model: null,
    generation: null,
    category: null,
    bundle: null,
  };

  // ── Vehicle tree from LF_BUNDLES keys ─────────────────────
  function buildVehicleTree() {
    const tree = {};
    Object.keys(LF_BUNDLES).forEach(function (handle) {
      const parts = handle.split('-');
      // Extract make (first segment), parse model and gen from title-style handle
      // Format: make-model-gen-years  e.g. chevy-silverado-1500-gen-4-2019-2025
      const raw = handle;
      // Detect make
      const makes = ['ford', 'chevy', 'gmc', 'ram', 'toyota', 'jeep'];
      let make = null;
      for (let m of makes) {
        if (raw.startsWith(m + '-')) { make = m; break; }
      }
      if (!make) return;

      const rest = raw.slice(make.length + 1); // e.g. silverado-1500-gen-4-2019-2025
      // Extract generation label (gen-N-years or jk-years, jl-years, etc.)
      const genMatch = rest.match(/(.+?)-(gen-\d+.*|jk.*|jl.*|jt.*|wk2.*|wl.*|trx.*|raptor.*)$/);
      let model, gen;
      if (genMatch) {
        model = genMatch[1];
        gen = genMatch[2];
      } else {
        // fallback: last dash segment is years
        const idx = rest.lastIndexOf('-');
        model = rest;
        gen = handle;
      }

      if (!tree[make]) tree[make] = {};
      if (!tree[make][model]) tree[make][model] = [];
      if (!tree[make][model].includes(handle)) tree[make][model].push(handle);
    });
    return tree;
  }

  // ── Pretty label from handle ───────────────────────────────
  function handleToLabel(handle) {
    return handle
      .replace(/-/g, ' ')
      .replace(/\b\w/g, function (c) { return c.toUpperCase(); })
      .replace(/\bGen\b/g, 'Gen')
      .replace(/\bSvt\b/g, 'SVT')
      .replace(/\bHd\b/g, 'HD')
      .replace(/\b2Hd\b/g, '2HD')
      .replace(/\bTrx\b/g, 'TRX')
      .replace(/\bJk\b/g, 'JK')
      .replace(/\bJl\b/g, 'JL')
      .replace(/\bJt\b/g, 'JT')
      .replace(/\bWk2\b/g, 'WK2')
      .replace(/\bWl\b/g, 'WL');
  }

  function makeLabel(make) {
    const map = { ford: 'Ford', chevy: 'Chevrolet', gmc: 'GMC', ram: 'RAM', toyota: 'Toyota', jeep: 'Jeep' };
    return map[make] || make.charAt(0).toUpperCase() + make.slice(1);
  }

  function genLabel(handle) {
    // Extract years from end of handle e.g. 2019-2025
    const m = handle.match(/(\d{4}-\d{4}|\d{4})$/);
    const years = m ? ' (' + m[1] + ')' : '';
    // Extract gen part
    const genM = handle.match(/-(gen-\d+|jk|jl|jt|wk2|wl|trx|raptor(?:-r)?(?:-gen-\d+)?(?:-svt)?)/i);
    const genPart = genM ? genM[1].toUpperCase().replace(/-/g, ' ') : '';
    return genPart + years;
  }

  // ── DOM refs ───────────────────────────────────────────────
  let elMake, elModel, elGen, elCats, elBundleArea, elToast;

  // ── Init ───────────────────────────────────────────────────
  function init() {
    const root = document.getElementById('lf-configurator');
    if (!root) return;
    if (typeof LF_BUNDLES === 'undefined') {
      console.error('LF_BUNDLES not loaded');
      return;
    }

    render(root);
    bindEvents();

    // Auto-load vehicle from URL param ?vehicle=handle
    const params = new URLSearchParams(window.location.search);
    const vehicleParam = params.get('vehicle');
    if (vehicleParam && LF_BUNDLES[vehicleParam]) {
      autoLoadVehicle(vehicleParam);
    }
  }

  // ── Render shell ───────────────────────────────────────────
  function render(root) {
    root.innerHTML = `
      <div class="lf-configurator">
        <div class="lf-configurator__header">
          <h1 class="lf-configurator__title">Build My <span>Truck</span></h1>
          <p class="lf-configurator__subtitle">Select your vehicle and build category to see your complete fitment package</p>
        </div>

        <div class="lf-vehicle-selector">
          <div class="lf-vehicle-selector__label">Step 1 — Select Your Vehicle</div>
          <div class="lf-vehicle-selector__dropdowns">
            <select class="lf-select" id="lf-make">
              <option value="">Select Make</option>
            </select>
            <select class="lf-select" id="lf-model" disabled>
              <option value="">Select Model</option>
            </select>
            <select class="lf-select" id="lf-gen" disabled>
              <option value="">Select Year / Gen</option>
            </select>
          </div>
        </div>

        <div class="lf-categories" id="lf-categories" style="display:none;"></div>

        <div id="lf-bundle-area">
          <div class="lf-state">
            <div class="lf-state__icon">🛻</div>
            <div class="lf-state__title">Select your vehicle to get started</div>
            <div class="lf-state__text">We'll show you pre-built packages tailored to your truck</div>
          </div>
        </div>
      </div>
      <div class="lf-toast" id="lf-toast">✓ Added to cart!</div>
    `;

    elMake = document.getElementById('lf-make');
    elModel = document.getElementById('lf-model');
    elGen = document.getElementById('lf-gen');
    elCats = document.getElementById('lf-categories');
    elBundleArea = document.getElementById('lf-bundle-area');
    elToast = document.getElementById('lf-toast');

    // Populate makes
    const tree = buildVehicleTree();
    Object.keys(tree).sort().forEach(function (make) {
      const opt = document.createElement('option');
      opt.value = make;
      opt.textContent = makeLabel(make);
      elMake.appendChild(opt);
    });

    window._lfTree = tree;
  }

  // ── Bind events ────────────────────────────────────────────
  function bindEvents() {
    elMake.addEventListener('change', function () {
      state.make = this.value;
      state.model = null;
      state.generation = null;
      state.category = null;

      elModel.innerHTML = '<option value="">Select Model</option>';
      elModel.disabled = !this.value;
      elGen.innerHTML = '<option value="">Select Year / Gen</option>';
      elGen.disabled = true;
      elCats.style.display = 'none';
      showEmpty();

      if (!this.value) return;
      const models = Object.keys(window._lfTree[this.value]).sort();
      models.forEach(function (model) {
        const opt = document.createElement('option');
        opt.value = model;
        opt.textContent = handleToLabel(model);
        elModel.appendChild(opt);
      });
    });

    elModel.addEventListener('change', function () {
      state.model = this.value;
      state.generation = null;
      state.category = null;

      elGen.innerHTML = '<option value="">Select Year / Gen</option>';
      elGen.disabled = !this.value;
      elCats.style.display = 'none';
      showEmpty();

      if (!this.value) return;
      const handles = window._lfTree[state.make][this.value];
      handles.forEach(function (handle) {
        const opt = document.createElement('option');
        opt.value = handle;
        opt.textContent = genLabel(handle);
        elGen.appendChild(opt);
      });
    });

    elGen.addEventListener('change', function () {
      state.generation = this.value;
      state.category = null;
      if (!this.value) { elCats.style.display = 'none'; showEmpty(); return; }
      renderCategories();
    });
  }

  // ── Auto load from URL param ───────────────────────────────
  function autoLoadVehicle(handle) {
    const makes = ['ford', 'chevy', 'gmc', 'ram', 'toyota', 'jeep'];
    let make = null;
    for (let m of makes) {
      if (handle.startsWith(m + '-')) { make = m; break; }
    }
    if (!make) return;

    elMake.value = make;
    elMake.dispatchEvent(new Event('change'));

    const tree = window._lfTree;
    const models = Object.keys(tree[make]);
    let foundModel = null;
    for (let model of models) {
      if (tree[make][model].includes(handle)) { foundModel = model; break; }
    }
    if (!foundModel) return;

    setTimeout(function () {
      elModel.value = foundModel;
      elModel.dispatchEvent(new Event('change'));
      setTimeout(function () {
        elGen.value = handle;
        elGen.dispatchEvent(new Event('change'));
      }, 50);
    }, 50);
  }

  // ── Render category tabs ───────────────────────────────────
  function renderCategories() {
    const bundles = LF_BUNDLES[state.generation];
    if (!bundles) { showEmpty(); return; }

    const cats = Object.keys(bundles);
    elCats.innerHTML = '';
    cats.forEach(function (cat) {
      const btn = document.createElement('button');
      btn.className = 'lf-cat-btn' + (cat === state.category ? ' active' : '');
      btn.textContent = cat;
      btn.dataset.cat = cat;
      btn.addEventListener('click', function () {
        state.category = cat;
        document.querySelectorAll('.lf-cat-btn').forEach(function (b) {
          b.classList.toggle('active', b.dataset.cat === cat);
        });
        renderBundle(bundles[cat]);
      });
      elCats.appendChild(btn);
    });
    elCats.style.display = 'flex';

    // Auto-select first category
    if (!state.category || !bundles[state.category]) {
      state.category = cats[0];
      elCats.querySelector('.lf-cat-btn').classList.add('active');
      renderBundle(bundles[cats[0]]);
    } else {
      renderBundle(bundles[state.category]);
    }
  }

  // ── Render bundle ──────────────────────────────────────────
  function renderBundle(bundle) {
    if (!bundle) { showEmpty(); return; }
    state.bundle = bundle;

    const w = bundle.wheel;
    const t = bundle.tire;
    const c = bundle.center_cap;
    const l = bundle.lug_nut;

    const wTotal = w.price * 4;
    const tTotal = t.price * 4;
    const cTotal = c ? c.price * 4 : 0;
    const lTotal = l ? l.price * l.qty : 0;
    const grand = wTotal + tTotal + cTotal + lTotal;

    elBundleArea.innerHTML = `
      <div class="lf-bundle">
        <div class="lf-bundle__items">
          ${renderItem('🔩', 'Wheels (×4)', w.title, w.size || '', w.price, wTotal)}
          ${renderItem('⭕', 'Tires (×4)', t.title, t.size || '', t.price, tTotal)}
          ${c
            ? renderItem('🔘', 'Center Caps (×4)', c.title, '', c.price, cTotal)
            : `<div class="lf-no-cap">Center cap not available for this wheel — contact us for options</div>`
          }
          ${l ? renderItem('🔧', `Lug Nuts (×${l.qty})`, l.title, l.thread_pitch || '', l.price, lTotal) : ''}
        </div>

        <div class="lf-bundle__sidebar">
          <div class="lf-summary">
            <div class="lf-summary__title">Build Summary</div>
            <div class="lf-summary__lines">
              <div class="lf-summary__line">
                <span class="lf-summary__line-label">Wheels ×4</span>
                <span class="lf-summary__line-value">$${fmt(wTotal)}</span>
              </div>
              <div class="lf-summary__line">
                <span class="lf-summary__line-label">Tires ×4</span>
                <span class="lf-summary__line-value">$${fmt(tTotal)}</span>
              </div>
              ${c ? `<div class="lf-summary__line">
                <span class="lf-summary__line-label">Center Caps ×4</span>
                <span class="lf-summary__line-value">$${fmt(cTotal)}</span>
              </div>` : ''}
              ${l ? `<div class="lf-summary__line">
                <span class="lf-summary__line-label">Lug Nuts ×${l.qty}</span>
                <span class="lf-summary__line-value">$${fmt(lTotal)}</span>
              </div>` : ''}
            </div>
            <div class="lf-summary__divider"></div>
            <div class="lf-summary__total-row">
              <span class="lf-summary__total-label">Total</span>
              <span class="lf-summary__total-price">$${fmt(grand)}</span>
            </div>
            <div class="lf-financing">
              <div class="lf-financing__title">Financing Estimate</div>
              <div class="lf-financing__options">
                ${financeRow(grand, 12)}
                ${financeRow(grand, 24)}
                ${financeRow(grand, 36)}
              </div>
              <div class="lf-financing__disclaimer">*Estimated. Actual rates via Affirm/Shop Pay may vary.</div>
            </div>
            <button class="lf-btn-cart" id="lf-add-to-cart">ADD BUILD TO CART</button>
            <div class="lf-btn-cart-note">Free shipping nationwide · Guaranteed fitment</div>
          </div>
        </div>
      </div>
    `;

    document.getElementById('lf-add-to-cart').addEventListener('click', addBundleToCart);
  }

  function renderItem(icon, category, title, meta, unitPrice, totalPrice) {
    return `
      <div class="lf-bundle-item">
        <div class="lf-bundle-item__icon">${icon}</div>
        <div class="lf-bundle-item__info">
          <div class="lf-bundle-item__category">${category}</div>
          <div class="lf-bundle-item__title">${title}</div>
          ${meta ? `<div class="lf-bundle-item__meta">${meta}</div>` : ''}
        </div>
        <div class="lf-bundle-item__price">
          <div class="lf-bundle-item__unit">$${fmt(unitPrice)} ea</div>
          <div class="lf-bundle-item__total">$${fmt(totalPrice)}</div>
        </div>
      </div>
    `;
  }

  function financeRow(total, months) {
    const rates = { 12: 1.15, 24: 1.20, 36: 1.25 };
    const monthly = (total * rates[months]) / months;
    return `<div class="lf-financing__option">
      <span class="lf-financing__months">${months} months</span>
      <span class="lf-financing__payment">$${fmt(monthly)}/mo</span>
    </div>`;
  }

  // ── Add to cart ────────────────────────────────────────────
  function addBundleToCart() {
    if (!state.bundle) return;
    const btn = document.getElementById('lf-add-to-cart');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    const bundle = state.bundle;
    const items = [];

    // Build cart items from handles
    // We need variant IDs — fetch each product by handle to get first variant
    const handles = [
      { handle: bundle.wheel.handle, qty: 4 },
      { handle: bundle.tire.handle, qty: 4 },
    ];
    if (bundle.center_cap && bundle.center_cap.handle) {
      handles.push({ handle: bundle.center_cap.handle, qty: 4 });
    }
    if (bundle.lug_nut && bundle.lug_nut.handle) {
      handles.push({ handle: bundle.lug_nut.handle, qty: bundle.lug_nut.qty });
    }

    // Fetch all variant IDs then add to cart
    Promise.all(handles.map(function (item) {
      return fetch('/products/' + item.handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          if (p && p.variants && p.variants.length > 0) {
            return { id: p.variants[0].id, quantity: item.qty };
          }
          return null;
        })
        .catch(function () { return null; });
    })).then(function (results) {
      const validItems = results.filter(Boolean);
      if (validItems.length === 0) {
        if (btn) { btn.disabled = false; btn.textContent = 'ADD BUILD TO CART'; }
        return;
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: validItems }),
      });
    }).then(function (res) {
      if (res) return res.json();
    }).then(function () {
      if (btn) { btn.disabled = false; btn.textContent = 'ADD BUILD TO CART'; }
      showToast('✓ Build added to cart!');
      // Update cart count if theme supports it
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }).catch(function (err) {
      console.error('Cart error:', err);
      if (btn) { btn.disabled = false; btn.textContent = 'ADD BUILD TO CART'; }
      showToast('⚠ Error adding to cart. Try again.');
    });
  }

  // ── Helpers ────────────────────────────────────────────────
  function fmt(n) {
    return Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function showEmpty() {
    elBundleArea.innerHTML = `
      <div class="lf-state">
        <div class="lf-state__icon">🛻</div>
        <div class="lf-state__title">Select your vehicle to get started</div>
        <div class="lf-state__text">We'll show you pre-built packages tailored to your truck</div>
      </div>`;
  }

  function showToast(msg) {
    elToast.textContent = msg;
    elToast.classList.add('visible');
    setTimeout(function () { elToast.classList.remove('visible'); }, 3000);
  }

  // ── Boot ───────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
